module.exports = __webpack_public_path__ + "assets/media/lunch.3dbeb6c7.mp3";